export default __webpack_public_path__ + "static/media/iPhone12ProMiddle.b7be584a.png";